import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  filter,
  map,
  Observable,
  OperatorFunction,
} from 'rxjs';
import { Application } from 'src/app/interfaces/application';
import { ResourcesService } from 'src/app/services/resources.service';
import {
  FormData,
  FormDataItem,
  FormElementItem,
} from 'src/app/interfaces/form-data';
@Component({
  selector: 'app-new-request-form',
  templateUrl: './new-request-form.component.html',
  styleUrls: ['./new-request-form.component.scss'],
})
export class NewRequestFormComponent {
  textSearch: string = '';
  activationSearch: string = '';
  customFunctions = {
    refresh: (field: FormDataItem, formData: FormData) => {
      console.log('$refresh()', field, formData);
    },
    action: (element: FormElementItem, formData: FormData) => {
      console.log('$action()', element, formData);
    },
  };

  @Input() set categories(input: any[]) {
    if (input?.[0])
      this._categories =
        input.flatMap(({ resources, ...category }) =>
          resources?.map((resource: any) => ({ ...category, ...resource }))
        ) || [];
    this.services = [...this._categories.filter((category: any) => category)];
  }
  private _categories: any[] = [];
  request: any;
  active = 1;

  faSearch = faSearch;
  selectedApp: Application | undefined;
  services: any[] = [];
  public model: any;
  private allowDismiss: boolean = true;

  formData: FormData | undefined;
  submitForm$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  validForm$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  isSubmitted: boolean = false;
  subFormsValidationStatus = {};

  constructor(
    private readonly fb: FormBuilder,
    private readonly appService: ResourcesService,
    private readonly modalService: NgbModal,
    private readonly activeModal: NgbActiveModal
  ) {
    combineLatest([this.submitForm$, this.validForm$])
      .pipe(
        filter(
          ([submitForm, validForm]) =>
            this.isSubmitted && submitForm && validForm
        ),
        map(([submitForm, validForm]) => {
          this.closeNewRequest(submitForm && validForm);
          this.submitForm$.next(null);
          this.validForm$.next(null);
        })
      )
      .subscribe();
    this.validForm$.subscribe(() => (this.isSubmitted = false));
  }

  getFormData(appId: string) {
    this.appService.getFormByService(appId).subscribe((data: any) => {
      this.formData = {
        fields: data.form.fields,
        elements: data.form.elements,
        description: data.description,
      };
    });
  }

  selectApp(app: Application) {
    this.selectedApp = app;
    this.allowDismiss = false;
    this.getFormData(this.selectedApp.id);
  }

  applySearchFilter() {
    const searchTerm = this.textSearch.toLowerCase();
    this.services = this._categories.filter(
      (service) =>
        service.name.toLowerCase().includes(searchTerm) ||
        service.label.toLowerCase().includes(searchTerm)
    );
  }

  search: OperatorFunction<string, readonly { name: string; icon: string }[]> =
    (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(200),
        map((term) =>
          term === ''
            ? []
            : this.services
                .filter(
                  (v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1
                )
                .slice(0, 10)
        )
      );

  formatter = (x: { name: string }) => x.name;

  public onFocus(e: Event): void {
    e.stopPropagation();
    setTimeout(() => {
      const inputEvent: Event = new Event('input');
      e.target?.dispatchEvent(inputEvent);
    }, 0);
  }

  closeModal() {
    this.allowDismiss = true;
    this.modalService.dismissAll();
  }

  confirmNewRequest(event: any) {
    this.isSubmitted = true;
    this.submitForm$.next(event.valid);
  }

  emitFormValidation(event: any) {
    this.isSubmitted && this.validForm$.next(event);
  }

  closeNewRequest(valid: boolean) {
    this.allowDismiss = true;
    this.activeModal.close({
      resourceId: this.selectedApp!.id,
      form: this.formData,
      valid,
      resourceName: this.selectedApp?.label,
    });
  }

  onFormEventChange() {
    this.isSubmitted = false;
  }
}
